import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import NumberFieldBase from 'common/Form/Fields/NumberFieldBase';

const valueTransformer = value => (value === '' ? null : Number(value));
const numberFormatProps = { inputMode: 'decimal' };

const NumberField = ({ field, onBlur, onChange, onFocus }) => {
  const stableTransformer = useCallback(valueTransformer, []);

  return (
    <NumberFieldBase
      field={field}
      numberFormatProps={numberFormatProps}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      valueTransformer={stableTransformer}
    />
  );
};

NumberField.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default NumberField;
